import CreateBundle from './create_bundle';

export default CreateBundle;
